import { createChecksumAddressProtocolInstanceValueOrThrow } from "@silo/types";

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const BalancerV2PriceProviderAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0x2F1aA93249bcc0DF7d89739F86308c7a270F5EEd",
  mainnetLlama: "0x0F07685A92c9B5c63a9e9Af205948BECeb8eb5f6",
  mainnetGrand: "0xbDBBf747402653A5aD6F6B8c49F2e8dCeC37fAcF",
  arbitrum: "0x7aAe7D92fbDd1De868c3398E1fade684c000f88d",
  optimism: "0x17f2CD2CfE241aFB03950c2ce2bF6b42193d4F04",
  base: "0x85b0273b0B415F9e28B9ce820240F4aa097F2a29",
  lrtbase: "0x0000000000000000000000000000000000000000",
  local: "0x856876834E49F105FdC5cb243Eca893DBac4e477",
  anvil: "0x2F1aA93249bcc0DF7d89739F86308c7a270F5EEd",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const BalancerV2SwapAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0xA40158686a5bDBe6C3Ea8a32F6e4E045C1C13F90",
  mainnetLlama: "0x196D312fd81412B6443620Ca81B41103b4E123FD",
  mainnetGrand: "0x12D73b8dC92961C71782154B70416c4A1fb7dD12",
  arbitrum: "0xb664Ca87Df549D110C59a96b10278439617D0813",
  optimism: "0xA826A337646AC01E89Ff935C996b449e4ba14BdB",
  base: "0xBc73c4aAD1aB674Afb3213a399682D70A773c3Dc",
  lrtbase: "0x0000000000000000000000000000000000000000",
  local: "0xd89d1df879C4f3Eece05c2356441bB4927Df6CD9",
  anvil: "0xA40158686a5bDBe6C3Ea8a32F6e4E045C1C13F90",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const InterestRateModelAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0x0000000000000000000000000000000000000000",
  mainnetLlama: "0x0000000000000000000000000000000000000000",
  mainnetGrand: "0x0000000000000000000000000000000000000000",
  arbitrum: "0x0000000000000000000000000000000000000000",
  optimism: "0x0000000000000000000000000000000000000000",
  base: "0x0000000000000000000000000000000000000000",
  lrtbase: "0x0000000000000000000000000000000000000000",
  local: "0x9AB17170dA72b96Cc9e91095c6c2565587770B23",
  anvil: "0x0000000000000000000000000000000000000000",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const PriceProvidersRepositoryAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0x7C2ca9D502f2409BeceAfa68E97a176Ff805029F",
  mainnetLlama: "0xa40111994F44C8add82eF495269e19109c9A982A",
  mainnetGrand: "0xE93CD89E29B5D22bED68dAe8448E241D5ed6d7C3",
  arbitrum: "0x5bf4E67127263D951FC515E23B323d0e3b4485fd",
  optimism: "0x1E915d8950f0C6bf9d01C603D33c50b6110beDA3",
  base: "0xF380F025675A868eD5614a1Dd77c6b05f4147004",
  lrtbase: "0x17f2CD2CfE241aFB03950c2ce2bF6b42193d4F04",
  local: "0xc467195154B7729Cc9161B18e5Acc83dFa42E941",
  anvil: "0x7C2ca9D502f2409BeceAfa68E97a176Ff805029F",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const SiloFactoryAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0x4D919CEcfD4793c0D47866C8d0a02a0950737589",
  mainnetLlama: "0x2c0fA05281730EFd3ef71172d8992500B36b56eA",
  mainnetGrand: "0xB7d391192080674281bAAB8B3083154a5f64cd0a",
  arbitrum: "0x4166487056A922D784b073d4d928a516B074b719",
  optimism: "0x6B14c4450a29Dd9562c20259eBFF67a577b540b9",
  base: "0x408822E4E8682413666809b0655161093cd36f2b",
  lrtbase: "0x2899b0C131225CbcE912Ba14Bbb7e1C88f2462B5",
  local: "0x976ED7147392f4F3d49ebd837A8f107a9853E894",
  anvil: "0x4D919CEcfD4793c0D47866C8d0a02a0950737589",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const SiloLensAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0x0e466FC22386997daC23D1f89A43ecb2CB1e76E9",
  mainnetLlama: "0x32a4Bcd8DEa5E18a12a50584682f8E4B77fFF2DF",
  mainnetGrand: "0x331243a425F7EE2468f0FddCe5cD83f58733Cc1C",
  arbitrum: "0xBDb843c7a7e48Dc543424474d7Aa63b61B5D9536",
  optimism: "0xd3De080436b9d38DC315944c16d89C050C414Fed",
  base: "0x196D312fd81412B6443620Ca81B41103b4E123FD",
  lrtbase: "0xE89D07da1438177eaa0AE7277D7D9A4dDdc16C0F",
  local: "0xa089dA1389b20186DEC6D217A606d146E753315f",
  anvil: "0x0e466FC22386997daC23D1f89A43ecb2CB1e76E9",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const SiloRepositoryAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0xd998C35B7900b344bbBe6555cc11576942Cf309d",
  mainnetLlama: "0xbcd67f35c7a2f212db0ad7f68fc773b5ac15377c",
  mainnetGrand: "0xbACBBefda6fD1FbF5a2d6A79916F4B6124eD2D49",
  arbitrum: "0x8658047e48CC09161f4152c79155Dac1d710Ff0a",
  optimism: "0xD2767dAdED5910bbc205811FdbD2eEFd460AcBe9",
  base: "0xa42001D6d2237d2c74108FE360403C4b796B7170",
  lrtbase: "0x1E915d8950f0C6bf9d01C603D33c50b6110beDA3",
  local: "0x61AE8B429f47c01945D050a69e5eCADab569B62a",
  anvil: "0xd998C35B7900b344bbBe6555cc11576942Cf309d",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const TokensFactoryAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0x0e37Df413f97fC198a84A21BC463C41b516AD622",
  mainnetLlama: "0x0000000000000000000000000000000000000000",
  mainnetGrand: "0x7Ed1160719AB280760FAa0Ba26CF13139904CbA5",
  arbitrum: "0xE067b967A36A136084Eb9DF0149Dde64F01ea7d1",
  optimism: "0x8A3C8F33b36B935f5E68108E664FB139B54eC0E8",
  base: "0x0f9d4fa99A0ca3c3c0DEdd287531c04E054c5f39",
  lrtbase: "0x19ee5a234Bf93f166E1664812b1E6E58593a4529",
  local: "0x689364100a7598309380e68AbcFB0cb54067f6c7",
  anvil: "0x0e37Df413f97fC198a84A21BC463C41b516AD622",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const UniswapV3PriceProviderAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0x9D46F86516d6083ACA3F9850D060CB62CD0F6924",
  mainnetLlama: "0x0000000000000000000000000000000000000000",
  mainnetGrand: "0x0000000000000000000000000000000000000000",
  arbitrum: "0xa44030057A005995851ae36553caeF7551d36BDd",
  optimism: "0x0000000000000000000000000000000000000000",
  base: "0x0000000000000000000000000000000000000000",
  lrtbase: "0x0000000000000000000000000000000000000000",
  local: "0x64e7AF8Cc573157dB2A872Eea39eCC36E05B0348",
  anvil: "0x9D46F86516d6083ACA3F9850D060CB62CD0F6924",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const UniswapV3SwapAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0xff36fdF7DE2aa239b0295d406A6ca5c25c6c9e99",
  mainnetLlama: "0x0000000000000000000000000000000000000000",
  mainnetGrand: "0x7a9AeBAf5A56E51cDe9BE7594e9257962a827613",
  arbitrum: "0xBe06E00666Dd1F42b0c65cFE17158906EfFb441E",
  optimism: "0xD4576D3B8CcEA7545b8F4cAB2671CF7b712fb73B",
  base: "0x0000000000000000000000000000000000000000",
  lrtbase: "0x0000000000000000000000000000000000000000",
  local: "0x98367eD5e4A15a8b89De22cEEa120Ff6104E200E",
  anvil: "0xff36fdF7DE2aa239b0295d406A6ca5c25c6c9e99",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const UniswapV3PriceProviderV2Address = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0xFAe64471ae04068e872C6A73C9F5a255c37dDbDC",
  mainnetLlama: "0x0000000000000000000000000000000000000000",
  mainnetGrand: "0x23755639583e92Db7bf1702E721DBc18fB99ba90",
  arbitrum: "0x124230c23ab32E22c69aCB48b38B4Dbaaaf74a40",
  optimism: "0xfed9c57cd8B76a4d197496eDDd8ae7A091DFEF1B",
  base: "0xA95aa71AEce270C7f2c777B1020A97503F7bd0a5",
  lrtbase: "0x0000000000000000000000000000000000000000",
  local: "0x04987cf8dA5fb969ACCEEe62ca720763413d4192",
  anvil: "0xFAe64471ae04068e872C6A73C9F5a255c37dDbDC",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const UniswapV3SwapV2Address = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0x96fBF6F0A431e64e05E22e5dBf6f1d92E5dda81f",
  mainnetLlama: "0xF89E18019A0bDC92dE8cc75633cC45014De732c8",
  mainnetGrand: "0xE856A3a604eA6795B9A3f4b195A2fF07463d2b3a",
  arbitrum: "0x597283Aa3e8f4A271E4874bC494448Bf37172c63",
  optimism: "0x66F61715A887AAfa0F585F72b3C626f9557601Fb",
  base: "0x0000000000000000000000000000000000000000",
  lrtbase: "0x0000000000000000000000000000000000000000",
  local: "0x7436aB8c5F057F93D389C246f9F39E6c3BeacCA6",
  anvil: "0x96fBF6F0A431e64e05E22e5dBf6f1d92E5dda81f",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const ChainlinkV3PriceProviderAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0xe37B8c83138caF12E57632D19c06Eb561D47e423",
  mainnetLlama: "0xb05F478d93C7063194f37535aD148242B8d1F1B8",
  mainnetGrand: "0xa3580D7a163616eb66B85C6FcAdB08dB02da6BEd",
  arbitrum: "0x9d0DDE842801448534263FF23C629EDC6B6B31ee",
  optimism: "0xE89D07da1438177eaa0AE7277D7D9A4dDdc16C0F",
  base: "0x44E9C695624dAd0bB3690A40C90e6D7964B32D3D",
  lrtbase: "0xFC403898DBAD4d3F1FC553Fed99d4Dd581BCD42f",
  local: "0xb1023Ad017368383A6Cc04c84CFf973371f1d41d",
  anvil: "0xe37B8c83138caF12E57632D19c06Eb561D47e423",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const LiquidationHelperAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0x931cf9F135a0cd54922256aAc33ca6151Ed735d3",
  mainnetLlama: "0x116C85d56002566223D5560268E04054D90d7B47",
  mainnetGrand: "0xFcc5C41bed687D9c8286b64D7Cd190Ae9E953A23",
  arbitrum: "0x069a9ad00821D359f6D667be56d35b49D7ad3a18",
  optimism: "0xc3f01B8c6B0338c952a5456e30a9FC26468C052A",
  base: "0xF89E18019A0bDC92dE8cc75633cC45014De732c8",
  lrtbase: "0xD4576D3B8CcEA7545b8F4cAB2671CF7b712fb73B",
  local: "0xF2969cCa4C85193d00Fe6c83323fe7EE8FE10726",
  anvil: "0x931cf9F135a0cd54922256aAc33ca6151Ed735d3",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const TowerAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0xF6a89F965E8c94da53f03b84563f103126ba5f23",
  mainnetLlama: "0x9d33d45AA7E1B45c65EA4b36b0c586B58a4796cE",
  mainnetGrand: "0x0AB251C6dAFB5598d6a6374030B1E0bfA6687dEb",
  arbitrum: "0x4182ad1513446861Be314c30DB27C67473541457",
  optimism: "0x413e64c7407D292D3EAcCc7FB878F3bC3522BB93",
  base: "0x22AacdEc57b13911dE9f188CF69633cC537BdB76",
  lrtbase: "0x847D9420643e117798e803d9C5F0e406277CB622",
  local: "0x9D346e4b6EcbFa2b09A438bA75DC09C5E0E887cf",
  anvil: "0xF6a89F965E8c94da53f03b84563f103126ba5f23",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const GOHMPriceProviderAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0xba53D3a08fB8dd4309881B4E8a3bc386ea0DDb1f",
  mainnetLlama: "0x0000000000000000000000000000000000000000",
  mainnetGrand: "0x0000000000000000000000000000000000000000",
  arbitrum: "0x0000000000000000000000000000000000000000",
  optimism: "0x0000000000000000000000000000000000000000",
  base: "0x0000000000000000000000000000000000000000",
  lrtbase: "0x0000000000000000000000000000000000000000",
  local: "0xa3f01C4F30bdE7C8910986E8cfa8484145EFF625",
  anvil: "0xba53D3a08fB8dd4309881B4E8a3bc386ea0DDb1f",
});

// WARNING: this is a generated file. Any manual overrides should be placed in the index.ts file.
export const CrvUSDViaUSDCPriceProviderETHAddress = createChecksumAddressProtocolInstanceValueOrThrow({
  mainnetLegacy: "0x0000000000000000000000000000000000000000",
  mainnetLlama: "0xa1c2837b7A899d6f89282e9bE9f1496D12e86bBa",
  mainnetGrand: "0x0000000000000000000000000000000000000000",
  arbitrum: "0x0000000000000000000000000000000000000000",
  optimism: "0x0000000000000000000000000000000000000000",
  base: "0x0000000000000000000000000000000000000000",
  lrtbase: "0x0000000000000000000000000000000000000000",
  local: "0x0000000000000000000000000000000000000000",
  anvil: "0x0000000000000000000000000000000000000000",
});

